<template>
  <div class="quality">
    <div class="quality-report-content">
      <div class="look-nav">
        <div class="look-nav-left">
          <div class="handle-wrapper" @click="backPath">
            <div class="icon-font">&#xe612;</div>
            <a>返回</a>
          </div>
        </div>
        <div class="look-nav-center">{{title}}</div>
        <div class="look-nav-right">
          <div class="handle-wrapper" @click="handleData">
            <div class="icon-font">&#xe678;</div>
            <a>提交</a>
          </div>
        </div>
      </div>
      <div class="look-inspection-content">
        <div class="look-inspection-content-list">
          <div class="input-contain" style="margin-right: 1vw">
            <div class="input-title">物料代码：</div>
            <DropDownInput type="2" :items="materialValue" content="" @sendValue="sendValueMaterial" @sendInfo="showInfoMaterial"></DropDownInput>
          </div>
          <div class="input-contain">
            <div class="input-title">烟叶简称：</div>
            <div class="input-wrapper">
              <input disabled="true" v-model="inputValue.materialName" placeholder=""/>
            </div>
          </div>
          <div class="input-contain" style="margin-right: 1vw">
            <div class="input-title">仓库位置：</div>
            <LoadingTreeStack :moduleType="moduleType"  :content="inputValue.siteName" :editCheckId="inputValue.siteId" v-on:sendInfo = "showDropInfo"></LoadingTreeStack>
          </div>
          <div class="input-contain">
            <div class="input-title">入库日期：</div>
            <div class="input-wrapper" style="margin-right: 0">
              <el-date-picker
                v-model="inputValue.dateOfInbound"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </div>
          </div>
        </div>
        <div class="look-inspection-content-list" style="position: relative;z-index: 8">
          <div class="input-contain">
            <div class="input-title" style="padding-left: 1.73vw">重量：</div>
            <DropDown :content="inputValue.qcWeight === 1 ? '合格' : '不合格'" :items="qualified" v-on:sendInfo = "showInfoWeight"></DropDown>
          </div>
          <div class="input-contain">
            <div class="input-title" style="padding-left: 1.73vw">水分：</div>
            <DropDown :content="inputValue.qcMoisture === 1 ? '合格' : '不合格'" :items="qualified" v-on:sendInfo = "showInfoMoisture"></DropDown>
          </div>
          <div class="input-contain">
            <div class="input-title" style="padding-left: 1.73vw">霉变：</div>
            <DropDown :content="inputValue.qcMildew === 1 ? '合格' : '不合格'" :items="qualified" v-on:sendInfo = "showInfoMildew"></DropDown>
          </div>
          <div class="input-contain">
            <div class="input-title" style="padding-left: 1.73vw">异味：</div>
            <DropDown :content="inputValue.qcOdor === 1 ? '合格' : '不合格'" :items="qualified" v-on:sendInfo = "showInfoOdor"></DropDown>
          </div>
        </div>
        <div class="look-inspection-content-list" style="position: relative;z-index: 7">
          <div class="input-contain">
            <div class="input-title" style="padding-left: 1.73vw">虫蛀：</div>
            <DropDown :content="inputValue.qcMoth === 1 ? '合格' : '不合格'" :items="qualified" v-on:sendInfo = "showInfoMoth"></DropDown>
          </div>
          <div class="input-contain">
            <div class="input-title" style="padding-left: 1.73vw">杂物：</div>
            <DropDown :content="inputValue.qcSundries === 1 ? '合格' : '不合格'" :items="qualified" v-on:sendInfo = "showInfoSundries"></DropDown>
          </div>
          <div class="input-contain">
            <div class="input-title" style="padding-left: 1.73vw">外观：</div>
            <DropDown :content="inputValue.qcExterior === 1 ? '合格' : '不合格'" :items="qualified" v-on:sendInfo = "showInfoExterior"></DropDown>
          </div>
          <div class="input-contain">
            <div class="input-title">人工判定：</div>
            <DropDown :content="inputValue.qcArtificialJudgement === 1 ? '合格' : '不合格'" :items="qualified" v-on:sendInfo = "showInfoArtificialJudgement"></DropDown>
          </div>
        </div>
        <div class="look-inspection-content-list">
          <div class="add-wrapper">
            <div class="input-title" style="padding-left: 0.83vw">负责人：</div>
            <div class="add-content">
              <div class="add-info" v-for="(data,index) in addData" :key="index">
                {{data.userName}}（{{data.userDepartment || '--'}}）
                <div class="icon-font close-icon" @click="deleteAddData(data.userId)">&#xe6f3;</div>
              </div>
              <div class="icon-font add-icon" @click="showAlert">&#xe605;</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="alert-box" v-if="show">
        <div class="alert-add-content">
          <div class="alert-content-title">添加负责人</div>
          <div class="alert-content-msg">
            <DropDownInput type="1" :items="custodianValue" content="" @sendValue="sendValue" @sendInfo="showInfo"></DropDownInput>
          </div>
          <div class="alert-content-btn">
            <div class="btn-cancel button" @click="cancelAdd">取消</div>
            <div class="btn-confirm button" @click="submitAdd">添加</div>
          </div>
        </div>
      </div>
    </transition>
    <img class="quality-icon" src="../../../assets/content-box.png"/>
  </div>
</template>

<script>
import DropDown from '../../../components/DropDownSingle.vue'
import LoadingTreeStack from '../../../components/LoadingTreeStack.vue'
import DropDownInput from '../../../components/DropDownInput.vue'
import {userList} from '../../../api/system'
import {materialList} from '../../../api/basic'
import {addQualityTesting} from '../../../api/maintain'
import {noEmpty} from '../../../tools/methods'
export default {
  name: 'LookInspection',
  components: { DropDown, LoadingTreeStack, DropDownInput },
  data () {
    return {
      userId: '',
      userName: '',
      userDepartment: '',
      custodianValue: [],
      materialValue: [],
      moduleType: '-1',
      date: '',
      show: false,
      addData: [],
      title: '',
      type: '',
      qualified: [
        {name: '合格', value: 1},
        {name: '不合格', value: 2}
      ],
      inputValue: {
        materialCode: '',
        materialName: '',
        siteId: '',
        siteName: '',
        siteType: '',
        qcWeight: 1,
        qcMoisture: 1,
        qcMildew: 1,
        qcOdor: 1,
        qcMoth: 1,
        qcSundries: 1,
        qcExterior: 1,
        qcArtificialJudgement: 1,
        qcType: this.$route.query.qcType,
        principalIdList: '',
        dateOfInbound: ''
      }
    }
  },
  created () {
    let type = parseInt(this.$route.query.qcType)
    console.log(type)
    if (type === 1) {
      this.title = '添加入库质检'
    } else if (type === 2) {
      this.title = '添加出库质检'
    } else if (type === 3) {
      this.title = '添加在库质检'
    }
    this.nowTime()
    this.handleSearchMaterialValue()
  },
  methods: {
    nowTime: function () {
      // 获取年月日
      let time = new Date()
      let year = time.getFullYear()
      let month = time.getMonth() + 1
      let day = time.getDate()

      // 检查是否小于10
      month = this.check(month)
      day = this.check(day)
      this.date = year + '-' + month + '-' + day
      this.inputValue.dateOfInbound = this.date
    },
    check: function (i) {
      let num
      i < 10 ? num = '0' + i : num = i
      return num
    },
    backPath: function () {
      this.$router.go(-1)
    },
    cancelAdd: function () {
      this.show = false
      this.name = ''
      this.section = ''
    },
    submitAdd: function () {
      if (this.userId !== '') {
        let canAdd = true
        this.addData.map(item => {
          if (item.userId === this.userId) {
            canAdd = false
          }
        })
        if (canAdd) {
          this.show = false
          this.addData.push({userId: this.userId, userName: this.userName, userDepartment: this.userDepartment})
          this.userId = ''
          this.userName = ''
          this.userDepartment = ''
          console.log(this.addData)
        } else {
          this.$message({
            message: '该人员已经添加!',
            type: 'success',
            center: 'true',
            duration: '1000'
          })
        }
      } else {
        this.$message({
          message: '请选择要添加的人员!',
          type: 'success',
          center: 'true',
          duration: '1000'
        })
      }
    },
    showAlert: function () {
      this.handleSearchValue()
    },
    deleteAddData: function (id) {
      let addData = []
      this.addData.map((data, index) => {
        if (data.userId !== id) {
          addData.push(data)
        }
      })
      this.addData = addData
      this.$message({
        message: '删除成功!',
        type: 'success',
        center: 'true',
        duration: '1000'
      })
    },
    showInfo: function (data) {
      console.log(data)
      this.userId = data.id
      this.userName = data.name
      this.userDepartment = data.deptName
    },
    sendValue: function (value) {
      this.handleSearchValue(value)
    },
    handleSearchValue: function (value) {
      let body = {
        keywork: value,
        page: 1,
        rows: 9999
      }
      userList(body).then(res => {
        console.log(res)
        this.custodianValue = res.data.rows
        this.show = true
      }).catch(err => {
        console.log(err)
      })
    },
    showInfoMaterial: function (data) {
      console.log(data)
      this.inputValue.materialName = data.name
      this.inputValue.materialCode = data.code
    },
    sendValueMaterial: function (value) {
      this.handleSearchMaterialValue(value)
    },
    handleSearchMaterialValue: function (value) {
      let body = {
        materialCode: value
      }
      materialList(body).then(res => {
        console.log(res)
        this.materialValue = res.data
      }).catch(err => {
        console.log(err)
      })
    },
    showDropInfo: function (data) {
      console.log(data)
      this.inputValue.siteName = data.gatherSite
      this.inputValue.siteId = data.id
      this.inputValue.siteType = data.siteType
    },
    showInfoWeight: function (data) {
      this.inputValue.qcWeight = data.value
    },
    showInfoMoisture: function (data) {
      this.inputValue.qcMoisture = data.value
    },
    showInfoMildew: function (data) {
      this.inputValue.qcMildew = data.value
    },
    showInfoOdor: function (data) {
      this.inputValue.qcOdor = data.value
    },
    showInfoMoth: function (data) {
      this.inputValue.qcMoth = data.value
    },
    showInfoSundries: function (data) {
      this.inputValue.qcSundries = data.value
    },
    showInfoExterior: function (data) {
      this.inputValue.qcExterior = data.value
    },
    showInfoArtificialJudgement: function (data) {
      this.inputValue.qcArtificialJudgement = data.value
    },
    handleData: function () {
      console.log(this.inputValue)
      let arr = []
      console.log(this.addData)
      if (this.addData.length > 0) {
        this.addData.map(item => {
          arr.push(item.userId)
        })
        this.inputValue.principalIdList = arr
      }
      if (
        noEmpty(this.inputValue.materialCode, '请选择物料代码') &&
        noEmpty(this.inputValue.siteId, '请选择仓库位置') &&
        noEmpty(this.inputValue.principalIdList, '请添加负责人')
      ) {
        addQualityTesting(this.inputValue).then(res => {
          console.log(res)
          if (res.code === 200) {
            this.$message({
              message: res.data,
              type: 'success',
              center: 'true',
              duration: '1000'
            })
          } else {
            this.$message({
              message: res.message,
              type: 'warning',
              center: 'true',
              duration: '1000'
            })
          }
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
}
</script>

<style scoped>
  @import "Quality.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/quality/AddInspection.vue